export default {
  small: '(max-width: 430px)',
  mobile: '(max-width: 799px)',
  desktop: '(min-width: 800px)',
  standard: '(min-width: 1024px)',
  large: '(min-width: 1400px)',
};
